module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-300-book-ac2811fb43df6aa075d63f9c54187b4e.woff";